module.exports = __webpack_public_path__ + "media/images/design/common/images/menu01-ef02710c9e1e379ce44be59d9774254f.jpg";